import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { AccountService } from '@app/core/services/account.service';

@Component({
    selector: 'app-work-in-progress',
    templateUrl: './work-in-progress.component.html',
    styleUrls: ['./work-in-progress.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class WorkInProgressComponent {
  private readonly accountService = inject(AccountService);

  handleLogout(): void {
    this.accountService.logout();
  }
}
